import React, { useState } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import moment from "moment";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import JoinNow from "../../assets/Join Now.svg";
import KnowMore from "../../assets/Know More.svg";
import Share from "../../assets/Share.svg";
import { useHistory } from "react-router-dom";

const PastWebinarRow = ({ webinar, index }) => {
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  function getActions() {
    return (
      <div>
        <button
          className="btn secondary-button rounded-pill px-3 secon_button mx-2"
          onClick={() => {
            history.push({
              pathname: `/doctor/account/webinars/know-more/${webinar.webinar_id}`,
              // state: {
              //   webinar_id: webinar.webinar_id,
              // },
            });
          }}
        >
          View Webinar
        </button>
      </div>
    );
  }

  const getMobileActionSheet = () => {
    return (
      <div className="my-3">
        <button
          className="btn secondary-button rounded-pill px-3 secon_button mx-2"
          style={{ width: "80%" }}
          onClick={() => {
            history.push({
              pathname: `/doctor/account/webinars/know-more/${webinar.webinar_id}`,
              // state: {
              //   webinar_id: webinar.webinar_id,
              // },
            });
          }}
        >
          View Webinar
        </button>
      </div>
    );
  };

  return (
    <>
      <div className="row previous-patient  patient-row-individual-row align-items-center shadow-sm my-lg-2 mx-lg-2 border rounded-sm my-2 mx-0 text-md-left text-center">
        <div className="col">{webinar.webinar_title}</div>
        <div className="col">
          {webinar.moderator_names && webinar.moderator_names.length > 0
            ? webinar.moderator_names
                .slice(0, 2)
                .map(
                  (data, index) =>
                    ` ${data.prefix_name} ${data.first_name} ${
                      data.middle_name ? data.middle_name : " "
                    } ${data.last_name}${
                      webinar.moderator_names.length > 1
                        ? webinar.moderator_names.length - 1 !== index
                          ? ","
                          : ""
                        : ""
                    }${
                      webinar.moderator_names.length > 2 && index == 1
                        ? "..."
                        : ""
                    }`
                )
            : "-"}
        </div>
        <div className="col">
          {
            <>
              <div>
                {moment(webinar.webinar_start_date_time.split("+")[0]).format(
                  "MMM DD, YYYY"
                )}
              </div>
              <div style={{ font: "normal normal normal 12px/21px Rubik" }}>
                {moment(webinar.webinar_start_date_time).format("hh:mm A")} -
                {moment(webinar.webinar_end_date_time).format("hh:mm A")}
              </div>
            </>
          }
        </div>
        <div className="col">{getActions()}</div>
      </div>

      <div
        key={index}
        className="previous-patient-mobile patient-row-individual-row shadow-sm border rounded-sm my-2 mx-2"
      >
        <div className="m-2">
          <div className="row">
            <div className="col patient-row-header">WEBINAR TITLE</div>
          </div>
          <div className="row mt-1">
            <div className="col" style={{ wordBreak: "break-all" }}>
              {webinar.webinar_title}
            </div>
          </div>
        </div>

        <div className="m-2">
          <div className="row">
            <div className="col patient-row-header">DATE & TIME</div>
            <div className="col patient-row-header">MODERATOR</div>
          </div>

          <div className="row mt-1">
            <div className={"col"}>
              {
                <>
                  <div>
                    {moment(
                      webinar.webinar_start_date_time.split("+")[0]
                    ).format("MMM DD, YYYY")}
                  </div>
                  <div style={{ font: "normal normal normal 12px/21px Rubik" }}>
                    {moment(
                      webinar.webinar_start_date_time.split("+")[0]
                    ).format("hh:mm A")}{" "}
                    -
                    {moment(webinar.webinar_end_date_time.split("+")[0]).format(
                      "hh:mm A"
                    )}
                  </div>
                </>
              }
            </div>
            <div className="col ">
              {webinar.moderator_names && webinar.moderator_names.length > 0
                ? webinar.moderator_names
                    .slice(0, 2)
                    .map(
                      (data, index) =>
                        ` ${data.prefix_name} ${data.first_name} ${
                          data.middle_name ? data.middle_name : " "
                        } ${data.last_name}${
                          webinar.moderator_names.length > 1
                            ? webinar.moderator_names.length - 1 !== index
                              ? ","
                              : ""
                            : ""
                        }${
                          webinar.moderator_names.length > 2 && index == 1
                            ? "..."
                            : ""
                        }`
                    )
                : "-"}
            </div>
          </div>
        </div>
        <hr className="mb-0" />
        <div className="text-center justify-content-center align-items-center">
          <div className="row">
            <div className="col">{getMobileActionSheet()}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PastWebinarRow;
